export function HeaderSkeleton() {
  return <header className="sticky top-0 z-40 bg-white/95 px-2 pt-2" aria-busy="true">
    <div className="mx-auto flex h-16 w-full max-w-[1400px] items-center justify-between rounded-xl border border-brand-line bg-white px-3 sm:px-6">
      <div className="h-7 w-36 animate-pulse rounded bg-brand-line"/>
      <div className="hidden gap-7 md:flex">{[96,112,92,104].map((width) => <div key={width} style={{ width }} className="h-4 animate-pulse rounded bg-brand-line"/>)}</div>
      <div className="h-10 w-24 animate-pulse rounded-full bg-brand-line"/>
    </div>
  </header>;
}

export function PageSkeleton({ cards = 3, compact = false }) {
  return <div className="mx-auto w-full max-w-[1120px] px-4 py-7 sm:px-6 sm:py-9" aria-busy="true" aria-label="Indlæser indhold">
    <div className="h-8 w-56 animate-pulse rounded bg-brand-line"/>
    <div className="mt-3 h-4 w-full max-w-md animate-pulse rounded bg-brand-line"/>
    <div className={compact ? "mt-6 space-y-3" : "mt-8 space-y-4"}>
      {Array.from({ length: cards }).map((_, index) => <div key={index} className={`${compact ? "h-24" : "h-36"} animate-pulse rounded-2xl border border-brand-line bg-white`} />)}
    </div>
  </div>;
}

